"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getSizeClassKey = getSizeClassKey;
exports.getVariantSizeClassKey = getVariantSizeClassKey;
var _utilities = require("../utilities");
var _responsiveProps = require("../utilities/responsiveProps");
// TODO: remove typecasting and fix variant issue
function getVariantSizeClassKey(variant, size, classes) {
  return (0, _responsiveProps.getResponsiveClassNamesForProp)(size, 'size').map(classe => classes[`${variant}${(0, _utilities.capitalizeFirstWord)(classe)}`]);
}
function getSizeClassKey(size, classes) {
  return (0, _responsiveProps.getResponsiveClassNamesForProp)(size, 'size').map(classe => classes[classe]);
}